var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hdqSection"},[_c('div',{staticClass:"left"},[_c('div',{staticClass:"icon"}),_vm._v(" "+_vm._s(_vm.title)+" "),_c('div',{staticClass:"leftSlot"},[_vm._t("left")],2)]),_c('div',{staticClass:"more",on:{"click":_vm.more}},[_vm._v(_vm._s(_vm.moreText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }